export function getAppParams(appParams) {
    return {
        appName: appParams.appName,
        appDefinitionId: appParams.appDefinitionId,
        appVersion: getAppVersion(appParams?.baseUrls?.staticsBaseUrl)
    };
}
export function getAppVersion(viewerScriptUrl) {
    viewerScriptUrl = viewerScriptUrl ?? '';
    const version = viewerScriptUrl.match(/^https:\/\/static\.parastorage\.com\/services\/[^/]+\/([^/]+)/);
    if (version) {
        return version[1];
    }
    if (viewerScriptUrl.includes('localhost')) {
        return 'localhost';
    }
    return 'not available';
}

//# sourceMappingURL=app-params.js.map